export const ROUTES = {
  // Backend step-to-route mapping
  START: '/start',             // STEP1_ADDR_CHECK
  LANDING: '/landing',         // STEP2_LANDING
  SELECT: '/select',           // STEP3_SELECT
  CONFIGURE: '/configure',     // STEP4_CONFIG
  CART: '/cart',               // STEP5_CART
  REVIEW: '/review',           // STEP6_REVIEW
  SUBMIT: '/submit',           // STEP7_SUBMIT
  DONE: '/done',               // DONE

  // FE-only routes (not mapped to a backend step)
  RESIDENTIAL: '/residential', // initial entry when no session exists
  BUSINESS: '/business',
  CHECKOUT: '/checkout',
  CONFIRMATION: '/confirmation',
} as const;

const STEP_TO_ROUTE: Record<string, string> = {
  STEP1_ADDR_CHECK: ROUTES.START,
  STEP2_LANDING: ROUTES.LANDING,
  STEP3_SELECT: ROUTES.SELECT,
  STEP4_CONFIG: ROUTES.CONFIGURE,
  STEP5_CART: ROUTES.CART,
  STEP6_REVIEW: ROUTES.REVIEW,
  STEP7_SUBMIT: ROUTES.SUBMIT,
  DONE: ROUTES.DONE,
};

/** Maps the navigation step returned by GET /sessions/:id to a frontend route. */
const NAV_STEP_TO_ROUTE: Record<string, string> = {
  SELECT: ROUTES.RESIDENTIAL,
  CHECKOUT: ROUTES.CHECKOUT,
  CONFIRMATION: ROUTES.DONE,
};

export const resolveRoute = (step: string): string =>
  STEP_TO_ROUTE[step] ?? ROUTES.START;

export const resolveNavStepRoute = (step: string): string | null =>
  NAV_STEP_TO_ROUTE[step] ?? null;
